module.exports = __webpack_public_path__ + "img/front.e7022e45.svg";